module.exports = __webpack_public_path__ + "static/microsoft-499ef8b6da63f993abf0c41a054bf74d.svg";